import { TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Button from "../../ui/Button";
import Modal from "../../ui/Modal";

interface BroadcastClearTranslationsButtonProps {
  count: number;
  onConfirm: () => void;
}

// A confirm-then-clear control for the whole translation list.
//
// Not the shared DeleteModal: that takes an apiFuncType returning Promise<IAxiosResponse<T>> and
// wraps it in toast.promise, so using it for a purely local form mutation would mean faking an
// HTTP response shape. This reuses the same Modal and Button primitives instead.
const BroadcastClearTranslationsButton: React.FC<
  BroadcastClearTranslationsButtonProps
> = ({ count, onConfirm }) => {
  const [show, setShow] = useState(false);

  const confirm = () => {
    setShow(false);
    onConfirm();
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShow(true)}
        className="flex items-center gap-1 text-sm font-semibold text-neutral"
      >
        <TrashIcon className="w-4 h-4" />
        Fshi të gjitha
      </button>
      <Modal
        position="center"
        show={show}
        onClose={() => setShow(false)}
        mini={true}
        hasHeader={false}
        calcHeight={false}
        buttonElement={<Button onClick={confirm}>Konfirmo</Button>}
      >
        <div className="flex justify-center mt-6">Konfirmo fshirjen</div>
        <p className="justify-center w-full flex mt-6 text-gray-600 text-sm px-4 text-center">
          {`Do të fshihen ${count} përkthime, përfshirë ato që i ke shkruar vetë. ` +
            "Ky veprim nuk mund të kthehet mbrapa."}
        </p>
      </Modal>
    </>
  );
};

export default BroadcastClearTranslationsButton;
